import { LockboxReturnCodes } from '../../types';
import * as yup from 'yup';
export const upsertLockboxLocationPayload = yup.object({
    id: yup.string().optional(),
    lockboxName: yup.string().required(),
    lockboxId: yup.string().required(),
    merchantAccountId: yup.number().integer().required(),
});
export const updateAgencyLockboxConfigSchema = yup.object({
    checkDisplayEnabled: yup.boolean().optional(),
    checkDownloadEnabled: yup.boolean().optional(),
    checkWritebackEnabled: yup.boolean().optional(),
});
export const lockboxSettlementsAndReturnsSchema = yup.object({
    settlements: yup
        .array(yup.object({
        lbxPaymentId: yup.string().required(),
        amount: yup.number().required(),
        settledDate: yup.date().required(),
    }))
        .default([]),
    returns: yup
        .array(yup.object({
        lbxPaymentId: yup.string().required(),
        amount: yup.number().required(),
        returnCode: yup.string().oneOf(Object.keys(LockboxReturnCodes)).required(),
    }))
        .default([]),
});
//# sourceMappingURL=lockbox.js.map